export default __webpack_public_path__ + "static/media/77.5e7b36a7.jpeg";